import React from 'react';
import {PropTypes} from 'prop-types';
import {PropTypesEx} from './proptypes.extensions';
import {NormalizeClassNameString, ObjectHasProperty} from './utils';

const inputIds = {};
const validationClasses = ['is-valid', 'is-invalid', 'is-warning'];
const preventDefault = e => e.preventDefault();

export class Checkbox extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.getInputId = this.getInputId.bind(this);
        this.renderInternal = this.renderInternal.bind(this);
    }

    getInputId(inputType) {
        const self = this;
        let result = self.props.id;

        if (result == null) {
            if (!Boolean(self._inputId)) {    
                inputIds[inputType] = (inputIds[inputType] || 0) + 1;
                self._inputId = `${inputType}-${inputIds[inputType]}`;
            }
            result = self._inputId;
        }

        return result;
    }

    renderInternal(controlType) {
        const self = this;

        const inputType = (controlType == 'switch') ? 'checkbox' : controlType;
        const props = {...self.props, id: self.getInputId(inputType)};
        const children = props.children;
        const inputId = props.id;
        const label = props.label;

        const classNames = NormalizeClassNameString(`custom-control custom-${controlType} ${(props.className || '')}`).split(' ');
        const inputClassName = classNames.filter(p => validationClasses.indexOf(p) >= 0).concat(['custom-control-input']).join(' ');
        const className = classNames.filter(p => validationClasses.indexOf(p) < 0).join(' ');

        const readOnly = Boolean(props.readOnly);
        const checked = Boolean(props.checked);
        const checkboxRef = props.checkboxRef;

        delete props.className;
        delete props.label;
        delete props.children;
        delete props.id;
        delete props.type;
        delete props.readOnly;
        delete props.checkboxRef;

        // if (readOnly) {
        //     props.onChange = preventDefault;
        // }

        return (
            <div className={className}>
                {!readOnly &&
                    <input 
                        id={inputId} 
                        type={inputType} 
                        className={inputClassName}
                        ref={checkboxRef}
                        {...props}
                    />
                }
                {readOnly && <span id={inputId} className={inputClassName + (checked ? ' checked' : '')} />}
                {/* <input 
                    id={inputId} 
                    type={inputType} 
                    className={inputClassName}
                    {...props}
                /> */}
                <label className="custom-control-label" htmlFor={inputId}>{label}</label>
                {children}
            </div>
        )
    }

    render() {
        return this.renderInternal('checkbox');
    }
}
Checkbox.propTypes = {
    id: PropTypesEx.elementId,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
}
Checkbox.defaultProps = {
    label: null
}

export class Radio extends Checkbox {
    render() {
        return this.renderInternal('radio');
    }
}
Radio.propTypes = {...Checkbox.propTypes};
Radio.defaultProps = {...Checkbox.defaultProps};

export class Switch extends Checkbox {
    render() {
        return this.renderInternal('switch');
    }
}
Switch.propTypes = {...Checkbox.propTypes};
Switch.defaultProps = {...Checkbox.defaultProps};

export function CheckboxWithIndeterminate(props) {
    const propsCopy = {...props};

    if (ObjectHasProperty(props, "indeterminate")) {
        const indeterminate = propsCopy.indeterminate;
        delete propsCopy.indeterminate;
        const checkboxRef = propsCopy.checkboxRef || React.useRef();
        propsCopy.checkboxRef = checkboxRef;

        React.useEffect(() => {
            propsCopy.checkboxRef.current.indeterminate = indeterminate;
        });
    }

    return <Checkbox {...propsCopy} />
}
